// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpandableContent_container__88k3B {
  margin: 37px 0px;
}
.ExpandableContent_container__88k3B p {
  margin: 0;
}

.ExpandableContent_title-container__UTZ5R {
  display: flex;
  cursor: pointer;
}

.ExpandableContent_primary__\\+5H63 {
  font-size: 20px;
  font-weight: bold;
}

.ExpandableContent_secondary__M8M3T {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/ExpandableContent/ExpandableContent.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAEE;EACE,SAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;AADF;;AAIA;EACE,eCXS;EDYT,iBCTK;ADQP;;AAIA;EACE,eClBO;ADiBT","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n.container {\n  margin: 37px 0px;\n  p {\n    margin: 0;\n  }\n}\n\n.title-container {\n  display: flex;\n  cursor: pointer;\n}\n\n.primary {\n  font-size: typography.$header-s;\n  font-weight: typography.$bold;\n}\n\n.secondary {\n  font-size: typography.$body-l;\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ExpandableContent_container__88k3B`,
	"title-container": `ExpandableContent_title-container__UTZ5R`,
	"primary": `ExpandableContent_primary__+5H63`,
	"secondary": `ExpandableContent_secondary__M8M3T`
};
export default ___CSS_LOADER_EXPORT___;
